import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "tooltip-exit-button-mask" }, null, -1 /* HOISTED */);
export default /*#__PURE__*/ _defineComponent({
    __name: 'MapMarkerTooltip',
    props: {
        text: {
            type: String,
            required: true,
        },
        position: {
            type: Object,
            required: true,
        },
        isVisible: {
            type: Boolean,
            required: true,
        },
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            var _component_GMapInfoWindow = _resolveComponent("GMapInfoWindow");
            return (_openBlock(), _createBlock(_component_GMapInfoWindow, {
                position: __props.position,
                opened: __props.isVisible
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", null, _toDisplayString(__props.text), 1 /* TEXT */),
                    _hoisted_1
                ]; }),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["position", "opened"]));
        };
    }
});
